import { httpClient } from "../common/http/httpClient";
import { getErrorMessage } from "../common/util/util";
import { ADDRESS_SEARCH, ADDRESS_SEARCH_GET, DROPDOWN_VALUES_PATH, FREIGHT_CREATE_ORDER, FREIGHT_ORDER_BY_TRACKING_NUMBER, FREIGHT_ORDER_HISTORY, REGISTER_EXTERNAL_USER_WITH_LINK } from "../constants/Constants";


export async function registerNewUser(reqBody: any) {
    return httpClient.post(REGISTER_EXTERNAL_USER_WITH_LINK, reqBody).then((res) => {
        return res;
    }).catch((err) => {
        console.log("Error in creating new user", err);
        return getErrorMessage(err);
    });
}

export async function getDropDownValues() {
    return httpClient.get(DROPDOWN_VALUES_PATH).then((res) => {
        return res;
    }).catch((err) => {
        console.log("Error in fetching dropdown values", err);
        return getErrorMessage(err);
    });
}

export async function getOrdersByUserAndBU(reqBody: any) {

    return httpClient.post(FREIGHT_ORDER_HISTORY, reqBody).then((res) => {
        return res;
    }).catch((err) => {
        console.log("Error in fetching order history", err);
        return getErrorMessage(err);
    });

}

export async function getOrderByTrackingNumber(reqBody: any) {

    return httpClient.post(FREIGHT_ORDER_BY_TRACKING_NUMBER, reqBody).then((res) => {
        return res;
    }).catch((err) => {
        console.log("Error in fetching order", err);
        return getErrorMessage(err);
    });

}

export async function getAddressDetails(reqBody: any) {

    return httpClient.post(ADDRESS_SEARCH, reqBody).then((res) => {
        return res;
    }).catch((err) => {
        console.log("Error in fetching address", err);
        return getErrorMessage(err);
    });

}

export async function loadMoreAddresses(reqBody: any, abortobj: AbortController) {

    return httpClient.postWithCancel(ADDRESS_SEARCH_GET, reqBody, abortobj).then((res) => {
        return res;
    }).catch((err) => {
        console.log("Error in fetching address", err);
        return getErrorMessage(err);
    });

}

export async function submitFreightOrderRequest(reqBody: any) {

    return httpClient.post(FREIGHT_CREATE_ORDER, reqBody).then((res) => {
        return res;
    }).catch((err) => {
        console.log("Error in submitting order", err);
        return getErrorMessage(err);
    });

}

